 <template>
  <div class="content_pages" id="report-metrics">
    <div class="table_info clearfix">
      <div class="table_info-col">
        <div class="table_info-title">{{ $t('report.metrics.total_visits') }}</div>
        <div class="table_info-number">{{ metrics.box_hits }}</div>
      </div>
      <div class="table_info-col">
        <div class="table_info-title">{{ $t('report.metrics.quizzes_completed') }}</div>
        <div class="table_info-number">{{ metrics.completed_submissions_count }}</div>
      </div>
      <div class="table_info-col">
        <div class="table_info-title">{{ $t('report.metrics.completion_rate') }}</div>
        <div class="table_info-number">{{ metrics.conclusion_rate }}</div>
      </div>
      <div class="table_info-col">
        <div class="table_info-title">{{ $t('report.metrics.average_time_to_complete') }}</div>
        <div class="table_info-number">{{ metrics.conclusion_average_time }}</div>
      </div>
    </div>
    <ul class="table_collumns">
      <Device :metric="devicesMetrics('desktop')" banner="kp-panel-pc" :title="$t('report.metrics.desktop')" />
      <Device :metric="devicesMetrics('tablet')" banner="kp-panel-tablet" :title="$t('report.metrics.tablet')" />
      <Device :metric="devicesMetrics('mobile')" banner="kp-panel-mobile" :title="$t('report.metrics.mobile')" />
      <Device :metric="devicesMetrics('others')" banner="kp-panel-others" :title="$t('report.metrics.others')" />
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Device from './Device';

export default {
  created() {
    this.$store.dispatch('metricsRequestData');
  },
  components: {
    Device,
  },
  computed: mapGetters({
    metrics: 'metricsData',
    devicesMetrics: 'devicesMetrics',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Metrics.vue?48245862
 **/